/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useRef } from 'react';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import CodeBlockNameContent from 'bundles/cml/editor/components/elements/code/dialogs/CodeBlockNameContent';
import CodeBlockNameDrawer from 'bundles/cml/editor/components/elements/code/dialogs/CodeBlockNameDrawer';
import { useFocusTrap } from 'bundles/cml/editor/utils/dialogUtils';
import type { CodeElement } from 'bundles/cml/shared/types/elementTypes';

import _t from 'i18n!nls/cml';

const styles = {
  dialog: css`
    width: 356px;
  `,
};

export type Props = {
  element: CodeElement;
  onClose: () => void;
};

export const CodeBlockNameDialog = ({ element, onClose }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useFocusTrap(ref);

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  return (
    <div css={styles.dialog} ref={ref} role="dialog" aria-modal="true" aria-label={_t('Edit code block name')}>
      <CodeBlockNameContent element={element} showBackButton onClose={handleClose} />
    </div>
  );
};

const CodeBlockNameDialogProvider = (props: Props) => {
  const isMobile = useMediaQuery(breakpoints.down('xs'));
  const Component = isMobile ? CodeBlockNameDrawer : CodeBlockNameDialog;

  return <Component {...props} />;
};

export default CodeBlockNameDialogProvider;
